"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC =
	"/image/new-version/casting/High-Pressure-Die-Casting/what-is-high-pressure-die-casting.jpg";

const ITEMS = [
	{ subtitle: "whatIsHpdcSubtitle1", desc: "whatIsHpdcDesc1" },
	{ subtitle: "whatIsHpdcSubtitle2", desc: "whatIsHpdcDesc2" },
] as const;

export default function WhatIsHPDC() {
	const t = useTranslations("new-high-pressure-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("whatIsHpdcTitle")}
				</h2>

				<div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:gap-10">
					<div className="flex w-full flex-col lg:min-w-0 lg:flex-1">
						<div className="space-y-6">
							{ITEMS.map((item) => (
								<div key={item.desc}>
									<h3 className="text-base font-semibold text-black sm:text-lg">{t(item.subtitle)}</h3>
									<p className="mt-2 text-sm leading-relaxed text-black md:text-base">{t(item.desc)}</p>
								</div>
							))}
						</div>
					</div>

					<div className="flex w-full lg:min-w-0 lg:flex-1">
						<div className="relative aspect-[4/2.5] w-full overflow-hidden shadow-lg">
							<Image
								src={IMAGE_SRC}
								alt={t("whatIsHpdcImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
